import { Star, Quote } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { TESTIMONIALS } from "@/data/content";

export const Testimonials = () => (
  <section id="testimonials" data-testid="testimonials-section" className="py-24 lg:py-36">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <Reveal className="mx-auto max-w-2xl text-center">
        <Eyebrow className="text-center">Testimonials</Eyebrow>
        <h2 className="mt-4 font-serif text-2xl leading-tight tracking-tight text-navy sm:text-3xl lg:text-4xl">
          What UK families share about Adeya
        </h2>
      </Reveal>

      <div className="mt-14 grid gap-6 lg:grid-cols-3">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.client} delay={i * 0.1}>
            <figure
              data-testid={`testimonial-card-${i + 1}`}
              className="flex h-full flex-col rounded-3xl border border-navy/[0.06] bg-white p-8 shadow-ambient transition-all duration-300 hover:-translate-y-1.5 hover:shadow-elevated"
            >
              <Quote className="h-8 w-8 text-mauve/50" aria-hidden="true" />
              <div className="mt-4 flex gap-1" aria-label="Five star rating">
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star key={s} className="h-4 w-4 fill-gold text-gold" aria-hidden="true" />
                ))}
              </div>
              <blockquote className="mt-4 flex-1 font-serif text-base italic leading-relaxed text-navy/90">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-6 border-t border-navy/[0.06] pt-5">
                <p className="text-sm font-semibold text-navy">{t.client}</p>
                <div className="mt-1.5 flex items-center justify-between">
                  <p className="text-xs text-charcoal/60">{t.location}, UK</p>
                  <span className="rounded-full bg-sage-light px-3 py-1 text-[0.65rem] font-semibold text-sage-dark">
                    {t.service}
                  </span>
                </div>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <p className="mt-8 text-center text-xs italic text-charcoal/50">
          Illustrative stories reflecting the experiences Adeya companionship is designed to create.
        </p>
      </Reveal>
    </div>
  </section>
);
